import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-slider-with-label',
    templateUrl: './slider-with-label.component.html',
    styleUrls: ['./slider-with-label.component.scss']
})
export class SliderWithLabelComponent {

    @Input() offLabel = 'off';
    @Input() onLabel = 'on';
    @Input() ngModel;
    @Input() checked;
}
